const TUTOR_DOMAIN = process.env.TUTOR_DOMAIN;

function getResourceLink(link: string) {
    const { protocol } = window.location;

    return `${protocol}//${TUTOR_DOMAIN}${link}`;
}

export default getResourceLink;
